import {api} from './api';

export const login = (username: FormDataEntryValue | string, password: FormDataEntryValue | string): Promise<any> => {
    const url: string = 'api-token-auth/'
    return api.post(url, {username, password})
}